import { TimeSlotButton, TimeSlotsContainer } from "./styled"

interface ITimeSlotsProps {
  timeSlots: string[]
  timeSelected: string
  setTimeSelected: (selectedTime: string) => void
}

export const TimeSlots = (props: ITimeSlotsProps) => {
  const { timeSlots, timeSelected, setTimeSelected } = props

  const formatTime = (time: string) => {
    return new Date(time).toLocaleTimeString("en-us", {
      minute: "numeric",
      hour: "numeric",
      hour12: true,
    })
  }

  return (
    <TimeSlotsContainer>
      {timeSlots.map(time => {
        return (
          <TimeSlotButton
            onClick={() => setTimeSelected(time)}
            selected={time === timeSelected}
          >
            {formatTime(time)}
          </TimeSlotButton>
        )
      })}
    </TimeSlotsContainer>
  )
}
